import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { useContext } from 'react';
import { ViewContext } from 'components/lib';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

export function ContentView(props) {

    const context = useContext(ViewContext);
    return (
        <Dialog
            maxWidth={false}
            sx={{}}
            open={props.show}
            onClose={() => context.contentView.hide(true)}
        >
            <DialogTitle>
                <FeatherIcon
                    onClick={() => context.contentView.hide(true)}
                    icon='x'
                    style={{ marginLeft: 'auto', cursor: 'pointer' }}

                />
            </DialogTitle>
            <DialogContent style={{ minWidth: '85vw', maxWidth: '85vw' }} className={StyleSheet.ancestor_container}>
                <props.view
                    course_id={props.course_id}
                    isPreview={true}

                />
            </DialogContent>

        </Dialog>
    )
}

